import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import RouteNames from "../../routes/type";
import { BackButton, Button } from "../../components";
import { classNames, navigateTo } from "../../helper";
import { claimStepsData } from "./types";
import { PiCheckBold } from "react-icons/pi";
import SelectPlan from "./SelectPlan";
import SelectItems from "./SelectItems";
import ItemDetailes from "./ItemDetailes";
import { FormProvider, useForm } from "react-hook-form";
import { connect, useDispatch } from "react-redux";
import {
  fetchClaimInfo,
  insertClaimItemDamages,
  insertClaimItems,
  submitClaim,
  updateCustomerInfo,
  setInProcessModal,
  setSubmitErrorModal,
} from "../../store/ace2-claim/actions";
import { isScopeLoading } from "../../store/scope-loading/helpers";
import { RootState } from "../../store/root-reducer";
import { Ace2ClaimScope } from "../../store/ace2-claim/types";
import queryString from "query-string";
import Loader from "../../components/Loader";
import ReportDamage from "./ReportDamage";
import { fetchAce2Options } from "../../store/user/actions";
import ReviewClaim from "./ReviewClaim";
import SubmitClaim from "./SubmitClaim";
import moment from "moment";
import VerifyContactInfo from "./VerifyContactInfo";
import { useTranslation } from "react-i18next";

import { getScopeError } from "../../store/scope-error/helpers";
import LinkNotValid from "../../components/LinkNotValid";
import UpdateContactInfo from "./UpdateContactInfo";
import { InProcessClaim, SubmitErrorModal } from "../../components/Modal";

const lastStepNum = claimStepsData.length;
const sucessStepNum = lastStepNum + 1;

function CreateClaim({
  loading,
  error,
  warranty_items,
  inProcessModal,
  submitErrorModal,
}) {
  let [searchParams] = useSearchParams();
  const formMethods = useForm({
    defaultValues: {
      customerInfo: {
        email: "",
        phone: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        allowSMS: true,
      },
      selectedPlan: "",
      selectedItems: [],
      claimItems: {},
      claimItemDamage: [],
    },
  });
  const {
    handleSubmit,
    formState: { isValid },
    getValues,
    setValue,
  } = formMethods;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const stepId: number = parseInt(searchParams.get("step") || "");
  const claimId: string = searchParams.get("claimId") || "";
  const warranty_id: string = searchParams.get("warranty_id") || "";

  useEffect(() => {
    if ((!stepId && !/^[0-9]*$/.test(`${stepId}`)) || stepId > sucessStepNum) {
      navigate(`/${RouteNames.CREATE_ACE2_CLAIM}?step=1`, { replace: true });
    }
    return () => {};
  }, [navigate, stepId]);

  useEffect(() => {
    dispatch(fetchAce2Options());
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (claimId && warranty_id) {
      dispatch(
        fetchClaimInfo({
          claimId,
          warranty_id,
        })
      );
    }
    return () => {};
  }, [claimId, dispatch, warranty_id]);

  const currentStep = claimStepsData.find((item) => item.step_num === stepId);

  const navigateToNextStep = (step) => {
    const parsed = queryString.parse(window.location.search);
    navigateTo(
      `/${RouteNames.CREATE_ACE2_CLAIM}?${queryString.stringify({
        ...parsed,
        step: step ?? stepId + 1,
      })}`
    );
  };

  const handleNext = () => {
    const values = getValues();
    switch (stepId) {
      case 1:
        // dispatch(
        //   createClaim({
        //     warranty_id: values?.selectedPlan,
        //   })
        // );
        break;

      case 2:
        navigateToNextStep(3);
        break;

      case 3:
        const mappedData = [];
        for (const key in values.claimItems) {
          const element = values.claimItems[key];
          const currntWarrantyItem =
            warranty_items?.find(
              ({ warranty_line_item_guid }) =>
                warranty_line_item_guid === element.warranty_line_item_guid
            ) || {};
          mappedData.push({
            warranty: warranty_id,
            warrnty_item_id: currntWarrantyItem?.id,
            warranty_line_item_guid: element.warranty_line_item_guid,
            name: element.name,
            id: element?.claimItemId,
            manufacturer: element.manufacturer,
            material: element.material,
            color: element.color,
            item_type: currntWarrantyItem?.name,
            model_number: currntWarrantyItem?.modelNumber,
            sku: currntWarrantyItem?.sku,
            item_descr: currntWarrantyItem?.itemDescription,
            quantity: currntWarrantyItem?.quantity?.toString(),
            vendor: currntWarrantyItem?.vendor,
          });
        }
        dispatch(insertClaimItems(mappedData));
        break;

      case 4:
        const mappedDamagesData = [];
        for (const key in values.claimItemDamage) {
          const element = values.claimItemDamage[key];
          element.forEach((item) =>
            mappedDamagesData.push({
              id: item?.damageId,
              claim_id: claimId,
              claim_item_id: key,
              damage_type: item?.damage_category,
              specific_damage: item?.specific_damage,
              specific_location: item?.damage_area,
              da_damage_date: item?.when_did_you_notice_the_damage
                ? moment(item?.when_did_you_notice_the_damage).format(
                    "YYYY-MM-DD"
                  )
                : null,
              how_did_occur: item?.how_did_it_happen,
              actions_taken: item?.did_you_take_any_steps_to_remedy,
              note_damage_area: item?.note,
            })
          );
        }
        dispatch(insertClaimItemDamages(mappedDamagesData));

        break;

      case 5:
        const customerInfo = values?.customerInfo;
        const mappedCustomerData = {
          Email: customerInfo?.email || "",
          Home_Phone: customerInfo?.phone || "",
          Mailing_Street: customerInfo?.address1 || "",
          Mailing_Street_2: customerInfo?.address2 || "",
          Mailing_City: customerInfo?.city || "",
          Mailing_State: customerInfo?.state || "",
          Mailing_Zip: customerInfo?.zip || "",
          sms_opt_in: customerInfo?.allowSMS,
        };
        dispatch(updateCustomerInfo(mappedCustomerData || {}));
        break;

      case 6:
        navigateToNextStep(7);
        break;

      case 7:
        dispatch(submitClaim());
        break;

      default:
        break;
    }
  };

  const stepComponents = {
    1: <SelectPlan key="stepId1" />,
    2: <SelectItems key="stepId2" />,
    3: <ItemDetailes key="stepId3" />,
    4: <ReportDamage key="stepId4" />,
    5: <UpdateContactInfo key="stepId5" />,
    6: <VerifyContactInfo key="stepId6" />,
    7: <ReviewClaim key="stepId7" />,
  };

  if (error === "CLAIM_NOT_FOUND") {
    return <LinkNotValid />;
  }

  if (stepId === sucessStepNum) {
    return (
      <Loader isLoading={loading}>
        <SubmitClaim />
      </Loader>
    );
  }

  return (
    <div className="px-4 space-y-3">
      <div className="mt-4 flex justify-between items-center">
        <BackButton
          onClick={() => {
            if (stepId === 2) {
              navigate(
                `/${RouteNames.SELECT_PLAN}?warranty_id=${warranty_id}&claimId=${claimId}`
              );
            } else if (stepId === 1) {
              navigate(`/${RouteNames.SELECT_SEARCH_METHOD}`);
            } else {
              navigateToNextStep(stepId - 1);
            }
          }}
        />
        <div className="flex flex-row gap-2">
          {claimStepsData.map(({ step_num: step }) => {
            const isCompleted = step < stepId;
            const isDraft = step > stepId;
            return (
              <button
                disabled
                key={step}
                className={classNames(
                  "size-7 flex rounded-full justify-center items-center text-base",
                  isDraft
                    ? "bg-[#009CAA] bg-opacity-15 text-[#009CAA] "
                    : "bg-[#009CAA] text-white"
                )}
              >
                {isCompleted ? <PiCheckBold size={16} color="white" /> : step}
              </button>
            );
          })}
        </div>
      </div>
      <h3 className="text-2xl font-semibold">{t(currentStep?.title)}</h3>
      <form onSubmit={handleSubmit(handleNext)}>
        <Loader isLoading={loading} />
        <FormProvider {...formMethods}>
          {stepComponents[stepId] || null}
        </FormProvider>
        <Button
          className="my-4"
          submit
          isLoading={loading}
          disabled={!(stepId === 4 || isValid)}
        >
          {stepId === lastStepNum ? t("Submit") : t("Next")}
        </Button>
      </form>
      <InProcessClaim
        isOpen={inProcessModal?.isShow}
        claimStatusCode={inProcessModal?.claimStatusCode}
        onClose={() =>
          dispatch(
            setInProcessModal({
              isShow: false,
              claimStatusCode: null,
            })
          )
        }
      />
      <SubmitErrorModal
        isOpen={submitErrorModal?.isShow}
        message={submitErrorModal?.message}
        onClose={() =>
          dispatch(
            setSubmitErrorModal({
              isShow: false,
              message: null,
            })
          )
        }
      />
    </div>
  );
}
const mapStateToProps = (state: RootState) => ({
  loading: isScopeLoading(state.scopeLoading, Ace2ClaimScope),
  warranty_items: state?.ace2Claim?.warranty_items || [],
  error: getScopeError(state.scopeError, Ace2ClaimScope),
  inProcessModal: state?.ace2Claim?.inProcessModal,
  submitErrorModal: state?.ace2Claim?.submitErrorModal,
});

export default connect(mapStateToProps)(CreateClaim);
